import React, { useState } from 'react';
import { Typography, Button, Input } from 'antd';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const CreateProject: React.FC = () => {
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');

  const handleCreateProject = () => {
    if (projectName && projectDescription) {
      console.log('Creating project:', { projectName, projectDescription });
      // Here you would typically call an API to create the project
      setProjectName('');
      setProjectDescription('');
    }
  };

  return (
    <div style={{
      maxWidth: '650px',
      margin: '0 auto',
      padding: '40px 20px'
    }}>
      {/* Title */}
      <Title level={2} style={{ color: '#FFFFFF', marginBottom: '16px', fontSize: '28px', fontWeight: 500 }}>
        Create a project
      </Title>

      {/* How to use projects section */}
      <div style={{
        background: '#2c2f2f',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px'
      }}>
        <Title level={5} style={{ color: '#FFFFFF', marginBottom: '8px', fontSize: '15px', fontWeight: 600 }}>
          How to use projects
        </Title>
        <Paragraph style={{ color: '#B8B8B8', fontSize: '13px', marginBottom: '8px', lineHeight: '1.5' }}>
          Projects help organize your construction work and leverage knowledge across multiple sites and teams. Upload blueprints, specs, permits, and reports to create organized collections that your team can reference throughout the project lifecycle.
        </Paragraph>
        <Paragraph style={{ color: '#B8B8B8', fontSize: '13px', marginBottom: 0, lineHeight: '1.5' }}>
          Start by creating a clear title and description to organize your project. You can always edit it later.
        </Paragraph>
      </div>

      {/* Form */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {/* Project Name */}
        <div>
          <Text style={{ color: '#FFFFFF', fontSize: '14px', display: 'block', marginBottom: '8px', fontWeight: 500 }}>
            What are you working on?
          </Text>
          <Input
            placeholder="Name your project"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            size="large"
            style={{
              background: '#262624',
              border: '1px solid #3A3A38',
              borderRadius: '8px',
              color: '#FFFFFF',
              fontSize: '14px',
              padding: '12px 14px',
              height: '46px'
            }}
          />
        </div>

        {/* Project Description */}
        <div>
          <Text style={{ color: '#FFFFFF', fontSize: '14px', display: 'block', marginBottom: '8px', fontWeight: 500 }}>
            What are you trying to achieve?
          </Text>
          <TextArea
            placeholder="Describe your project, goals, scope, deliverables, timeline..."
            value={projectDescription}
            onChange={(e) => setProjectDescription(e.target.value)}
            rows={4}
            style={{
              background: '#262624',
              border: '1px solid #3A3A38',
              borderRadius: '8px',
              color: '#FFFFFF',
              fontSize: '14px',
              padding: '12px 14px',
              resize: 'none',
              lineHeight: '1.5'
            }}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '24px'
      }}>
        <Button
          size="large"
          onClick={() => {
            setProjectName('');
            setProjectDescription('');
          }}
          style={{
            background: 'transparent',
            border: '1px solid #3A3A38',
            color: '#B8B8B8',
            height: '46px',
            padding: '0 24px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          size="large"
          onClick={handleCreateProject}
          disabled={!projectName || !projectDescription}
          style={{
            background: projectName && projectDescription
              ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
              : '#3A3A38',
            border: 'none',
            height: '46px',
            padding: '0 24px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 600,
            color: projectName && projectDescription ? '#FFFFFF' : '#6B6B69',
            cursor: projectName && projectDescription ? 'pointer' : 'not-allowed'
          }}
        >
          Create project
        </Button>
      </div>
    </div>
  );
};

export default CreateProject;